import * as React from "react";
import cs from "classnames";
import { EvalObs } from "../../api/EvalWorkflowApi";
import { ParamOption, ParamType } from "../../api/GrammarApi";
import ParamTypeSelectors from "../param-types/ParamTypeSelectors";
import { OnParamSelectProp } from "../param-types/ParamTypeSelector";

type ObsLineProps = {
  obs: EvalObs;
  bones: Array<ParamOption>;
  selected: boolean;
  paramTypes?: ParamType[];

  onClick: () => void;
  onDelete: () => void;
  onParamSelect?: OnParamSelectProp;
};

export default function ObsLine({
  obs,
  bones,
  selected,
  onClick,
  onDelete,
  paramTypes = [],
  onParamSelect,
}: ObsLineProps) {
  const badgeLabel = obs?._badge?.label || "";
  const badgeColor = obs?._badge?.color || null;

  const boneLabel = React.useMemo(() => {
    const bone = bones.find((bone) => bone.code === obs.boneCode);
    return bone ? bone.label : "";
  }, [bones, obs.boneCode]);

  const handleDelete = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation();
    onDelete();
  };

  return (
    <div onClick={onClick} className={cs("label-obs-item", { selected })}>
      <div className="row">
        <div className="col-10">
          <div className="row">
            <div className="col-8">
              <div className="pl-1">
                <span className="pl-1" style={{ color: badgeColor }}>
                  {obs.obsType} {badgeLabel} {boneLabel && <>: {boneLabel}</>}
                </span>
              </div>
            </div>
          </div>
          {paramTypes.length > 0 && (
            <div className="row">
              <div className="col-11">
                <div className="pl-1">
                  <ParamTypeSelectors
                    paramTypes={paramTypes}
                    onSelect={onParamSelect}
                    getValue={(paramCode) => obs.valueByParam?.[paramCode]}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="col text-right">
          <button className="btn btn-sm btn-outline-light" onClick={handleDelete}>
            <i className="fa fa-trash" />
          </button>
        </div>
      </div>
    </div>
  );
}
